import './resource-allocation-agent-assignment-query-table/resource-allocation-agent-assignment-query-table.component';
import './resource-allocation-agent-assignment-query-table/resource-allocation-agent-assignment-query-table.scss';

import './resource-allocation-agent-assignment-query-table-row/resource-allocation-agent-assignment-query-table-row.component';
import './resource-allocation-agent-assignment-query-table-row/resource-allocation-agent-assignment-query-table-row.scss';

import './resource-allocation-agent-assignment-table/resource-allocation-agent-assignment-table.component';
import './resource-allocation-agent-assignment-table/resource-allocation-agent-assignment-table.scss';

import './resource-allocation-agent-assignment-table-row/resource-allocation-agent-assignment-table-row.component';
import './resource-allocation-agent-assignment-table-row/resource-allocation-agent-assignment-table-row.scss';


import './resource-allocation-item/resource-allocation-item.component';
import './resource-allocation-item/resource-allocation-item.scss';

import './resource-allocation-panel-view/resource-allocation-panel-view.component';
import './resource-allocation-panel-view/resource-allocation-panel-view.scss';

import './resource-allocation-select/resource-allocation-select.component';
import './resource-allocation-select/resource-allocation-select.scss';

import './resource-allocation-select-list/resource-allocation-select-list.component';
import './resource-allocation-select-list/resource-allocation-select-list.scss';

import './resource-allocation-timeline-logs-view/resource-allocation-timeline-logs-view.component';

import './resource-capacity/resource-capacity.component';
import './resource-capacity/resource-capacity.scss';

import './resource-allocation-panel-edit/resource-allocation-panel-edit.component';
import './resource-allocation-panel-edit/resource-allocation-panel-edit.scss';

import './resource-allocation-panel-info/resource-allocation-panel-info.component';
import './resource-allocation-panel-info/resource-allocation-panel-info.scss';

import './resource-color/resource-color.component';
import './resource-color/resource-color.scss';

import './resource-info/resource-info.component';
import './resource-info/resource-info.scss';

import './resource-multi-select-list/resource-multi-select-list.component';
import './resource-multi-select-list/resource-multi-select-list.scss';

import './resources-allocations-timeline/resources-allocations-timeline.component';
import './resources-allocations-timeline/resources-allocations-timeline.scss';

import './resources-allocations-view/resources-allocations-view.component';
import './resources-allocations-view/resources-allocations-view.scss';

import './resources-display-list/resources-display-list.component';
import './resources-display-list/resources-display-list.scss';

import './resources-gantt-timeline-test/resources-gantt-timeline-test.component';
import './resources-gantt-timeline-test/resources-gantt-timeline-test.scss';

import './resources-gantt-view/resources-gantt-view.component';
import './resources-gantt-view/resources-gantt-view.scss';


import './resources-multiple-select/resources-multiple-select.component';
import './resources-multiple-select/resources-multiple-select.scss';

import './service-area-segments-view/service-area-segments-view.component';
import './service-area-segments-view/service-area-segments-view.scss';

import './edit-resource-allocation-dialog-view/edit-resource-allocation-dialog-view.component';
import './edit-resource-allocation-dialog-view/edit-resource-allocation-dialog-view.scss';

import './resource-allocations-agent-bulk-assignment-table/resource-allocations-agent-bulk-assignment-table.component';
import './resource-allocations-agent-bulk-assignment-table/resource-allocations-agent-bulk-assignment-table.scss';

import './resource-allocations-agent-bulk-assignment-table-row/resource-allocations-agent-bulk-assignment-table-row.component';
import './resource-allocations-agent-bulk-assignment-table-row/resource-allocations-agent-bulk-assignment-table-row.scss';

import './resource-dialog-form/resource-dialog-form.component';
import './resource-dialog-form/resource-dialog-form.scss';
